import postAPI from './postAPI.js'

export default async function postAddStepToTaskFlow(stepData) {
    const data = await postAPI('admin/taskflows/steps/add', stepData);
    return data;
}
